import { index } from '@/store/index';

export function translate(s: string): string {
  return index.getters.translate(s);
}
